<div class="container-fluid">
  <div class="row">
    <!-- <a class="col-4" routerLink="../roleslist">
      << Back to roles list</a> -->
  </div>
  <div class="col-12">
    <div class="row">
      <div class="col-10 pl-0">
        <div class="page-header">
          <h2>Manage Roles</h2>
          <p>Create new role and customize permissions.</p>
        </div>
      </div>
    </div>
    <div class="row">
      <a class="back-button pr-3 pl-0 back-btn-white-bg ng-star-inserted" routerLink="../roleslist">
        <i aria-hidden="true" class="fa fa-chevron-circle-left"></i>Back</a>
    </div>
  </div>

  <form #createRoleForm="ngForm" name="form" class="container-fluid" (ngSubmit)="createNewRole(createRoleForm)">
    <div class="content-container">
      <div class="form-row">
        <div class="form-group col-3">
          <label class="control-lbl mt-2 label-cls d-block required">Company</label>
          <mat-form-field style="width:100%">
            <mat-select name="companyId" [(ngModel)]="companyId" (selectionChange)="companySelected($event)"
              class="matformfieldwidth1 w-100 date-field" [disabled]="isDisabled" required>
              <mat-option *ngFor="let company of listCompany" [value]="company.id">
                {{company.companyName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-3">
          <label class="control-lbl mt-2 label-cls d-block required">Role Name</label>
          <input type="text" class="form-control" name="roleName" [(ngModel)]="role.roleName" placeholder="Role Name"
            #roleName="ngModel" [ngClass]="{ 'is-invalid': createRoleForm.submitted && roleName.invalid }" required />
          <div *ngIf="createRoleForm.submitted && roleName.invalid" class="invalid-feedback">
            <div *ngIf="roleName.errors.required">Role Name is required.</div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-8">
          <label>Description</label>
          <input type="text" class="form-control" name="description" [(ngModel)]="role.description"
            placeholder="Description">
        </div>
      </div>
      <p-divider type="dotted"></p-divider>
      <div class="form-row">
        <div class="form-group col-8">
          <p-checkbox [(ngModel)]="isImmigrationRole" name="immigrationRole" [binary]="true" class="float-left mr-2"
            (onChange)="immigrationChecked()" inputId="binary"></p-checkbox>
          <label class="float-left" for="binary">Is immigration role</label>
        </div>
      </div>


      <p-accordion class="role-accordion" *ngIf="isImmigrationRole">
        <p-accordionTab>
          <ng-template pTemplate="header">
            <div class="row notify">
              <div class="col-12">
                <label> Standard Permission </label>
              </div>
            </div>
          </ng-template>
          <div class="form-row">
            <div class="form-group col-8">
              <table class="im-card-no-border-table table-striped-simple" mat-table [dataSource]="dataSource">

                <!-- Permissions Column -->
                <ng-container matColumnDef="permissions" sticky>
                  <th mat-header-cell *matHeaderCellDef> Permissions </th>
                  <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>

                <!-- description Column -->
                <ng-container matColumnDef="description" sticky>
                  <th mat-header-cell *matHeaderCellDef> Description </th>
                  <td mat-cell *matCellDef="let element"> {{element.description}} </td>
                </ng-container>

                <!-- Permission role Column -->
                <ng-container matColumnDef="permissionRole">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null" class="bordered-checkbox"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox (click)="$event.stopPropagation()" [(ngModel)]="element.isSelected"
                      class="bordered-checkbox" (ngModelChange)="handleChange(element)"
                      name="isSelected_{{element.id}}"></mat-checkbox>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
        </p-accordionTab>

      </p-accordion>

      <p-accordion class="role-accordion" *ngIf="!isImmigrationRole">
        <p-accordionTab>
          <ng-template pTemplate="header">
            <div class="row notify">
              <div class="col-12">
                <label> Forms Build Permission </label>
              </div>
            </div>
          </ng-template>
          <div class="form-row">
            <div class="form-group col-8">
              <table class="im-card-no-border-table table-striped-simple" mat-table [dataSource]="fbDataSource">

                <!-- Permissions Column -->
                <ng-container matColumnDef="permissions" sticky>
                  <th mat-header-cell *matHeaderCellDef> Permissions </th>
                  <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>

                <!-- description Column -->
                <ng-container matColumnDef="description" sticky>
                  <th mat-header-cell *matHeaderCellDef> Description </th>
                  <td mat-cell *matCellDef="let element"> {{element.description}} </td>
                </ng-container>

                <!-- Permission role Column -->
                <ng-container matColumnDef="permissionRole">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null" class="bordered-checkbox"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox (click)="$event.stopPropagation()" [(ngModel)]="element.isSelected"
                      class="bordered-checkbox" (ngModelChange)="handleChange(element)"
                      name="isSelected_{{element.id}}"></mat-checkbox>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
        </p-accordionTab>

      </p-accordion>

      <p-accordion class="role-accordion" *ngIf="modulePermission">
        <p-accordionTab>
          <ng-template pTemplate="header">
            <div class="row notify">
              <div class="col-12">
                <label> {{modulePermission.moduleName}} </label>
              </div>
            </div>
          </ng-template>
          <div class="form-row">
            <div class="form-group col-8">
              <table class="im-card-no-border-table table-striped-simple" mat-table [dataSource]="moduleDataSource">

                <!-- Permissions Column -->
                <ng-container matColumnDef="permissions" sticky>
                  <th mat-header-cell *matHeaderCellDef> Permissions </th>
                  <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>

                <!-- description Column -->
                <ng-container matColumnDef="description" sticky>
                  <th mat-header-cell *matHeaderCellDef> Description </th>
                  <td mat-cell *matCellDef="let element"> {{element.description}} </td>
                </ng-container>

                <!-- Permission role Column -->
                <ng-container matColumnDef="permissionRole">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggleModule(modulePermission) : null"
                      class="bordered-checkbox"
                      [checked]="selectedMod(modulePermission) && isAllSelectedModule(modulePermission)"
                      [indeterminate]="selectedMod(modulePermission) && !isAllSelectedModule(modulePermission)">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox (click)="$event.stopPropagation()" [(ngModel)]="element.isSelected"
                      class="bordered-checkbox" (ngModelChange)="handleChange(element)"
                      name="isSelected_{{element.id}}"></mat-checkbox>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
        </p-accordionTab>

      </p-accordion>






      <div class="form-row">
        <div class="form-group col-2">
          <input type="submit" class="im-btn im-btn-primary im-btn-md ml-auto" value="Save" />
        </div>
      </div>
    </div>
  </form>
</div>
